// extracted by mini-css-extract-plugin
module.exports = {"padding-label":"src-_components-___JobQuerySearchPanel-module__padding-label___1T3i5","form":"src-_components-___JobQuerySearchPanel-module__form___hZNDf"};